import { render } from "./Sidebar_Screen8.vue?vue&type=template&id=29910376&scoped=true"
import script from "./Sidebar_Screen8.vue?vue&type=script&lang=js"
export * from "./Sidebar_Screen8.vue?vue&type=script&lang=js"

import "./Sidebar_Screen8.vue?vue&type=style&index=0&id=29910376&lang=css"
import "./Sidebar_Screen8.vue?vue&type=style&index=1&id=29910376&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29910376"]])

export default __exports__